import { render, staticRenderFns } from "./CounterpartTable.vue?vue&type=template&id=6df38dcc&scoped=true"
import script from "./CounterpartTable.vue?vue&type=script&lang=js"
export * from "./CounterpartTable.vue?vue&type=script&lang=js"
import style0 from "./CounterpartTable.vue?vue&type=style&index=0&id=6df38dcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df38dcc",
  null
  
)

export default component.exports